import Vue from 'vue'

// 销售的年度目标列表
export function getSaleTargetList(data) {
  return Vue.axios({
    url: '/api/sale_target/list',
    method: 'get',
    params: {...data}
  })
}

//post 保存销售的年度目标
export function saveSaleTargetRow(data) {
  return Vue.axios({
    url: '/api/sale_target/save',
    method: 'post',
    data: {...data}
  })
}

// 删除销售的年度目标
export function deleteSaleTargetRow(data) {
  return Vue.axios({
    url: '/api/sale_target/delete',
    method: 'get',
    params: {...data}
  })
}

// 销售的年度目标列表
export function getSaleUserOptions() {
  return Vue.axios({
    url: '/api/sale_target/saleUserOptions',
    method: 'get',
  })
}
